export default __webpack_public_path__ + "static/lane_3000.png";